/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_DescriptionInputs */

const ja_contact_form_description = /** @type {(inputs: Contact_Form_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下を入力してください。<br/> 担当者より折り返しご連絡をさせていただきます。`)
};

const en_contact_form_description = /** @type {(inputs: Contact_Form_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please fill out the following form. <br/> A representative will get back to you shortly.`)
};

/**
* | output |
* | --- |
* | "Please fill out the following form. <br/> A representative will get back to you shortly." |
*
* @param {Contact_Form_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_form_description = /** @type {((inputs?: Contact_Form_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_form_description(inputs)
	return en_contact_form_description(inputs)
});